import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssociationExitNoteCoaService {

  private URL = environment.api + "api/erp/exit-note/coa/association";

  constructor(
    private http: HttpClient
  ) {}

  getAssociationsByExitNote(entryNoteId: number) {
    return this.http.get(`${this.URL}/${entryNoteId}/exitNotes`);
  }

  getAssociationsByCoa(coaId: number) {
    return this.http.get(`${this.URL}/${coaId}/coa`);
  }

  createAssociation(entryNoteId: number, coaId: number) {
    let params = new HttpParams()
      .set('exitNoteId', entryNoteId)
      .set('coaId', coaId);

    return this.http.post(`${this.URL}/create`, null, { params });
  }


  deleteAssociation(companyId: number, entryNoteId?: number, coaId?: number) {
    let params = new HttpParams();
    if (entryNoteId) params = params.set('exutNoteId', entryNoteId);
    if (coaId) params = params.set('coaId', coaId);

    return this.http.delete(`${this.URL}/delete`, {params});
  }


}
